export const MOUSEDOWN = 'mousedown';
export const TOUCHSTART = 'touchstart';
export const EVENTS = [MOUSEDOWN, TOUCHSTART];
